import {
  APP_LANGUAGE_ENGLISH,
  APP_LANGUAGE_HEBREW,
  APP_THEME_DARK,
  APP_THEME_INVERSE,
  APP_THEME_LIGHT,
  APP_THEME_SYSTEM
} from "../settings/appSettings.js";
import { onKey } from "../shortcuts/onKey.js";
import { shortcutsById } from "../shortcuts/shortcutRegistry.js";

export async function toggleLanguageForTesting({ appSettings, handleLanguageChange }) {
  const nextLanguage = appSettings.language === APP_LANGUAGE_HEBREW
    ? APP_LANGUAGE_ENGLISH
    : APP_LANGUAGE_HEBREW;

  await handleLanguageChange(nextLanguage);
}

export async function cycleThemeForTesting({ appSettings, handleThemeChange }) {
  const themeOrder = [
    APP_THEME_SYSTEM,
    APP_THEME_LIGHT,
    APP_THEME_DARK,
    APP_THEME_INVERSE
  ];
  const currentIndex = themeOrder.indexOf(appSettings.theme);
  const safeIndex = currentIndex >= 0 ? currentIndex : 0;
  const nextTheme = themeOrder[(safeIndex + 1) % themeOrder.length];

  await handleThemeChange(nextTheme);
}

export function createAppShortcutBindings({
  appSettings,
  cycleToNextYear,
  handleLanguageChange,
  handleThemeChange,
  navigateSidebarSection,
  navigateToPage
}) {
  return [
    onKey(
      shortcutsById.get("go-home").binding,
      () => navigateToPage("home"),
      { allowInInput: true }
    ),
    onKey(
      shortcutsById.get("go-expenses").binding,
      () => navigateToPage("expenses"),
      { allowInInput: true }
    ),
    onKey(
      shortcutsById.get("go-analysis").binding,
      () => navigateToPage("analysis"),
      { allowInInput: true }
    ),
    onKey(
      shortcutsById.get("go-budget").binding,
      () => navigateToPage("budget"),
      { allowInInput: true }
    ),
    onKey(
      shortcutsById.get("go-settings").binding,
      () => navigateToPage("settings"),
      { allowInInput: true }
    ),
    onKey(
      shortcutsById.get("go-help").binding,
      () => navigateToPage("help"),
      { allowInInput: true }
    ),
    onKey(
      shortcutsById.get("next-year").binding,
      () => {
        cycleToNextYear().catch((error) => {
          console.error("Failed to cycle to the next year.", error);
        });
      },
      { allowInInput: true }
    ),
    onKey(
      "Alt+ArrowDown",
      () => navigateSidebarSection(1),
      { allowInInput: true }
    ),
    onKey(
      "Alt+ArrowUp",
      () => navigateSidebarSection(-1),
      { allowInInput: true }
    ),
    onKey(
      "Alt+L",
      () => {
        toggleLanguageForTesting({ appSettings, handleLanguageChange }).catch((error) => {
          console.error("Failed to toggle app language for testing.", error);
        });
      },
      { allowInInput: true }
    ),
    onKey(
      "Alt+P",
      () => {
        cycleThemeForTesting({ appSettings, handleThemeChange }).catch((error) => {
          console.error("Failed to cycle app theme for testing.", error);
        });
      },
      { allowInInput: true }
    ),
    onKey(
      shortcutsById.get("open-dev").binding,
      () => navigateToPage("dev", "index"),
      { allowInInput: true }
    )
  ];
}
